/* istanbul ignore file */
import React from 'react';
import { Box, Center, Heading, Text } from '@chakra-ui/react';
import { SystemTranslationKeys } from '@common/entities';

import { useSystemTranslation } from 'hooks';

const PageNotFound = () => {
  const { t, tSystem } = useSystemTranslation();

  return (
    <Center height="100vh">
      <Box textAlign="center">
        <Heading as="h1" size="2xl" mb="4">
          {tSystem(SystemTranslationKeys.error.pageNotFound)}
        </Heading>
        <Text fontSize="lg">
          {t(
            SystemTranslationKeys.error.pageNotFoundMessage,
            'The page you are looking for does not exist.',
          )}
        </Text>
      </Box>
    </Center>
  );
};

export default PageNotFound;
